import React, { useEffect, useState } from "react";
import MainLayout from "../layout/main";
import Loading from "../component/loading";
import { useFileDownloader } from "../api/fileDownloader";
import presentation from "./../assets/img/presentation 1.png";
import download from "./../assets/img/cloud_download1.png";
import { BASE_API_URL } from "../config";
import { UserRoles } from "../storage/enums";
import { RoleViewSelector } from "../component/roleViewSelector";
import axios from "axios";
import { storageApi } from "../storage/storageApi";
import { IoClose } from "react-icons/io5";

const AnnouncementPage = () => {
  const [isLoading, setIsLoading] = useState([]);
  const [downloadList, setLoadingList] = useState([]);

  const downloadManager = useFileDownloader();
  const [isFileDownloading, setIsFileDownloading] = useState(false);
  const [showLaterMessage, setShowLaterMessage] = useState(false);

  const hideMessage = () => {
    setShowLaterMessage(false);
  };

  const downloadFile = ({ url }, silent = false) => {
    const filename = url.split("/").pop();
    if (!silent) {
      setIsFileDownloading(true);
      setLoadingList((c) => {
        c.push(url);
        return c;
      });
    }

    axios({
      url,
      method: "GET",
      responseType: "blob",
      headers: {
        authorization: `Bearer ${storageApi.getUserToken()}`,
      },
    })
      .then((response) => {
        const href = URL.createObjectURL(response.data);
        if (!silent) {
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        }

      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 404) {
            const { data } = error.response;

            data
              .text()
              .then((errorText) => {
                try {
                  const errorJson = JSON.parse(errorText);
                  console.log(errorJson.detail || "خطا (404)");
                  if (
                    errorJson.detail == "No cached file is currently available."
                  ) {
                    setShowLaterMessage(true);
                    !isFileDownloading &&
                      downloadFile({
                        url: BASE_API_URL + "/docs/export-program-data/",
                        },
                        true,
                      );
                  } else {
                    alert("خطا ۴۰۴");
                  }
                } catch (parseError) {
                  alert("خطا (404)");
                }
              })
              .catch(() => alert("خطا (404)"));
          } else {
            console.error("Error:", error.response.status, error.response.data);
            alert("خطایی در بارگیری فایل رخ داده است");
          }
        } else {
          console.error("Network error or request was blocked", error);
          alert("خطای شبکه‌ای رخ داده است.");
        }
      })
      .finally(() => {
        setIsFileDownloading(false);
        setTimeout(() => {
          setLoadingList((c) => {
            return c.filter((x) => x !== url);
          });
        }, 4000);
      });
  };

  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative p-8 min-h-[180px]">
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] h-full mx-auto">
            <div className="text-3xl text-center font-bold">
              <span className=" text-greenblue">عملکرد و ارزیابی</span>
            </div>
          </div>
        </div>
        <RoleViewSelector>
          <div
            className=" md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-2 grid-cols-1 gap-6"
            userRole={UserRoles.User}
          >
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-data/",
                    });
                  setIsLoading([true]);
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(کل برنامه)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
          </div>
          <div
            className=" md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-2 grid-cols-1 gap-6"
            userRole={UserRoles.Admin}
          >
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-data/",
                    });
                  setIsLoading([true]);
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>( کل برنامه های استان)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-sazman/",
                    });
                  setIsLoading([false, true]);
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>( بر اساس زیرمجموعه ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>

            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-majmooe/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(بر اساس مجموعه ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-city/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(بر اساس شهرستان ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>

            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-monasebat/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(بر اساس مناسبت ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>

            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-customers-ranks/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(رتبه بندی کاربران)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
          </div>
          <div
            className=" md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-2 grid-cols-1 gap-6"
            userRole={UserRoles.Sazman}
          >
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-data/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>( کل برنامه های مجموعه)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-sazman/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>( بر اساس زیرمجموعه ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>

            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-state/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(بر اساس استان ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-monasebat/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(بر اساس مناسبت ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-customers-ranks/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(رتبه بندی کاربران)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
          </div>

          <div
            className=" md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-2 grid-cols-1 gap-6"
            userRole={UserRoles.SazmanOstan}
          >
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-data/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>
                    (کل برنامه های مجموعه - استان)
                  </span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-sazman/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>( بر اساس زیرمجموعه ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>

            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-city/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(بر اساس شهرستان ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-monasebat/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(بر اساس مناسبت ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-customers-ranks/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(رتبه بندی کاربران)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
          </div>

          <div
            className=" md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-2 grid-cols-1 gap-6"
            userRole={UserRoles.ModireKol}
          >
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/check-excel-cache/",
                      // url: BASE_API_URL + "/docs/export-program-data/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(کل برنامه های کشور)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-sazman/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>( بر اساس زیرمجموعه ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-majmooe/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>( بر اساس مجموعه ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-state/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(بر اساس استان ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-program-monasebat/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(بر اساس مناسبت ها)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
            <div
              className="rounded-xl px-4 md:py-4 py-2 bg-greenblue-light bg-opacity-30 border-[1.5px] border-greenblue
           w-50% flex justify-between items-center cursor-pointer"
            >
              <div
                className="flex gap-4 items-center text-sm font-normal"
                onClick={() => {
                  !isFileDownloading &&
                    downloadFile({
                      url: BASE_API_URL + "/docs/export-customers-ranks/",
                    });
                }}
              >
                <img src={presentation} className="w-12" />
                <span>
                  بارگیری عملکرد و ارزیابی
                  <span className={"text-xs"}>(رتبه بندی کاربران)</span>
                </span>
              </div>
              <span>
                <img src={download} />
              </span>
            </div>
          </div>
        </RoleViewSelector>
      </div>
      {isFileDownloading && (
        <div
          className={`z-[10000] bg-gray-900 bg-opacity-40 w-screen h-screen fixed top-0 left-0`}
        >
          <div className="md:w-[550px] w-[550px] max-h-[600px] rounded-xl gap-2 flex justify-center text-center p-8 bg-white absolute top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%]">
            <Loading isLoading={isFileDownloading} color={"blue"} />
            در حال آماده سازی فایل ...
          </div>
        </div>
      )}
      {showLaterMessage && (
        <div
          className={`z-[10000] bg-gray-900 bg-opacity-40 w-screen h-screen fixed top-0 left-0`}
        >
          <div className="md:w-[550px] w-[550px] max-h-[600px] rounded-xl gap-2 flex flex-col  text-center p-8 bg-white absolute top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%]">
            فایل شما در حال پردازش می‌باشد و تا دقایقی دیگر آماده می‌شود.
            <br />
            لطفا ده دقیقه دیگر دوباره مراجعه بکنید.
            <div className="h-12 pt-6">
              <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                onClick={hideMessage}
              >
                باشد
              </button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default AnnouncementPage;
